import React from 'react';
import { Users, UserCheck, User } from 'lucide-react';
import GradientStatCard from './GradientStatCard';
import { colors } from './constants';

const StatCards = ({ statistics, computedStatistics }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    <GradientStatCard 
      title="Total des demandeurs" 
      value={statistics.totalDemandeurs} 
      icon={<Users />} 
      gradient={colors.gradient.orange} 
    />
    
    <GradientStatCard 
      title="Hommes" 
      value={`${statistics.hommes} (${computedStatistics.pourcentageHommes}%)`} 
      icon={<UserCheck />} 
      gradient={colors.gradient.blue} 
      subtitle={`Sur ${computedStatistics.totalAvecProfil} profils renseignés`}
    />
    
    <GradientStatCard 
      title="Femmes" 
      value={`${statistics.femmes} (${computedStatistics.pourcentageFemmes}%)`} 
      icon={<User />} 
      gradient={colors.gradient.pink} 
      subtitle={`Sur ${computedStatistics.totalAvecProfil} profils renseignés`}
    />

    <GradientStatCard 
      title="Sans profil" 
      value={computedStatistics.totalSansProfil} 
      icon={<User />} 
      gradient={colors.gradient.purple} 
      subtitle="Profil non renseigné"
    />
  </div>
);

export default StatCards;
